module.exports = __webpack_public_path__ + "static/media/subscription.e0f2e624.png";